import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { auth, writeNewUser, fetchUserProfile, ensureUserTheme } from "../../firebase";
import { useDispatch } from "react-redux";
import { setUser } from "../store/usersSlice";
import styles from "./LoginPage.module.css";


export const LoginPage = () => {
  const dispatch = useDispatch();
  const [loginType, setLoginType] = useState("login");
  const [error, setError] = useState('');
  const [userCredentials, setUserCredentials] = useState({});

  const handleCredentials = (e) => {
    e.preventDefault();
    setUserCredentials({...userCredentials, [e.target.name]: e.target.value});
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (loginType === "login") {
        const userCredential = await signInWithEmailAndPassword(auth, userCredentials.email, userCredentials.password);
        const userId = userCredential.user.uid;
        const theme = await ensureUserTheme(userId);
        const profile = await fetchUserProfile(userId);
        dispatch(
          setUser({
            id: userId,
            email: profile.email,
            listsId: profile.listsId,
            name: profile.name,
            theme: theme || "original_light",
          })
        );
        
      } else {
        if (userCredentials.password !== userCredentials.confirmPassword) {
          alert("Password must match!")
          return;
        }

        const userCredential = await createUserWithEmailAndPassword(auth, userCredentials.email, userCredentials.password, userCredentials.name);
        const userId = userCredential.user.uid;
        const theme = await ensureUserTheme(userId);
        const newListsId = await writeNewUser(userCredentials.email, userCredentials.name);

        dispatch(setUser({id: userId, email: userCredentials.email, listsId: newListsId, name: userCredentials.name, theme: theme || "original_light" }));
      }
    } catch (err) {
      let msg = "Login failed. Please try again.";

      if (err?.code === "auth/invalid-credential" || err?.code === "auth/wrong-password") {
        msg = "Invalid email or password";
      } else if (err?.code === "auth/user-not-found") {
        msg = "No account found for that email";
      } else if (err?.message) {
        msg = err.message;
      }

      setError(msg);
    }
  }

  const handlePasswordReset = () => {
    const email = prompt("Enter your email");
    
    if (email) {
      sendPasswordResetEmail(auth, email);
      alert("If that account exists you should see the instructions in your email box!");
    } else {
      return;
    }
  }
  
  return (
    <div className={styles.login_body}>
      <div className={styles.logo}>Nerd Lists</div>
      <div className={styles.left_panel_desktop}>
        <h1>Hello!</h1>
        <p>
          Welcome to Nerd Lists! This is just a little website I created for my friends and I to keep track of the movies we needed to watch together. <br/>
          This site can be used to create a list of whatever you want though so don't feel like your list has to only be movies!
          Please be understanding as I slowly make improvements to this site to ensure a better user experience.
          The website looks ugly because it is! I have no eye for design and websites aren't my forte 🤓.
          Thank you and enjoy...maybe!
        </p>
      </div>
      <div className={styles.sign_in_container}>
      <form>
        <h1>{loginType === "login" ? "Login" : "Signup"}</h1>
        <input 
          onChange={(e) => {handleCredentials(e)}}
          type="email"
          name="email"
          placeholder="Email"
        />
        <input
          onChange={(e) => {handleCredentials(e)}}
          type="password"
          name="password"
          placeholder='Password'
          required="required"
        />
        {
          loginType === "signup" &&
          <>
            <input
              onChange={(e) => {handleCredentials(e)}}
              type="password"
              name="confirmPassword"
              placeholder='Confirm Password'
            />
            <input
              onChange={(e) => {handleCredentials(e)}}
              type="name"
              name="name"
              placeholder='Name'
            />
          </>
        }

        {
          error &&
          <div className="error_text">{error}</div>
        }
       <p className={styles.password_reset} onClick={handlePasswordReset}>Forgot password?</p>
        <button className={styles.login_button} onClick={(e) => {handleSubmit(e)}}>
          {loginType === "login" ? "Login" : "Signup"}
        </button>

        </form>
        <p id={styles.switch_type} onClick={() => {loginType === "login" ? setLoginType("signup") : setLoginType("login")}}>
        {
          loginType === "login" ?
          "Don't have an account?"
          :
          "Already have an account?"
        }
        </p>
      </div>
    </div>
  )
}
